<template>
  <a-modal
    centered
    :title="`${actType}角色`"
    :width="850"
    :body-style="{ maxHeight:'500px', overflowY:'auto' }"
    :mask-closable="false"
    :visible="showForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
        <a-spin :spinning="loading">
          <a-form-model-item label="名称" prop="name" ref="name">
            <a-input v-model="model.name" />
          </a-form-model-item>
          <a-form-model-item label="拥有权限" v-if="privileges.length > 0">
            <a-tree
              v-if="showForm"
              v-model="privilegeIds"
              placeholder="请选择"
              checkable
              :tree-data="privileges"
              :replace-fields="replaceFields"
              @check="autoCheck"
            />
          </a-form-model-item>
          <a-form-model-item label="启用" prop="enabled">
            <a-switch v-model="model.enabled" />
          </a-form-model-item>
          <a-form-model-item label="展示禁用优化师" prop="show_display_worker">
            <a-switch v-model="model.show_display_worker" />
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
